/**
 * Tone maps for the VMA `*_LEVEL` badges.
 *
 * Each column gets its own mapping: the vocabularies differ, and the polarity
 * flips between supply and demand — high wholesale supply is bad news, high
 * retail demand is good — so a single shared good/bad scale would colour half
 * of them wrongly.
 */
export type LevelTone = 'good' | 'neutral' | 'warn' | 'bad';

export const WS_SUPPLY_TONE: Record<string, LevelTone> = {
  low: 'good', medium: 'neutral', high: 'warn', excessive: 'bad',
};
export const WS_DEMAND_TONE: Record<string, LevelTone> = {
  hot: 'good', warm: 'neutral', cold: 'bad',
};
export const RETAIL_SUPPLY_TONE: Record<string, LevelTone> = {
  low: 'good', neutral: 'neutral', high: 'warn',
};
export const RETAIL_DEMAND_TONE: Record<string, LevelTone> = {
  high: 'good', neutral: 'neutral', low: 'bad',
};
